module.exports = __webpack_public_path__ + "static/media/all-transactions.20173da8.png";